import _typeof from '@babel/runtime/helpers/esm/typeof';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { DSAccordion, DSAccordionItem } from '@elliemae/ds-basic/Accordion';
import ChevronDown from '@elliemae/ds-icons/ChevronDown';
import ChevronRight from '@elliemae/ds-icons/ChevronRight';
import { QueryBuilderContext } from '../QueryBuilderContext/QueryBuilderContext.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _convertPropToCssClas = convertPropToCssClassName('query-builder-output'),
    cssClassName = _convertPropToCssClas.cssClassName;

var DisplayOutput = /*#__PURE__*/function (_Component) {
  _inherits(DisplayOutput, _Component);

  var _super = _createSuper(DisplayOutput);

  function DisplayOutput() {
    var _this;

    _classCallCheck(this, DisplayOutput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      _this.setState(function (_ref) {
        var show = _ref.show;
        return {
          show: !show
        };
      });
    });

    return _this;
  }

  _createClass(DisplayOutput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var show = this.state.show;
      var _this$props = this.props,
          showLabel = _this$props.showLabel,
          hideLabel = _this$props.hideLabel;
      return /*#__PURE__*/React.createElement(QueryBuilderContext.Consumer, null, function (_ref2) {
        var format = _ref2.format;
        var display = '';

        try {
          display = _typeof(format) === 'object' ? JSON.stringify(format) : format;
        } catch (e) {
          display = e;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: cssClassName
        }, /*#__PURE__*/React.createElement(DSAccordion, {
          activeValue: show,
          onChange: _this2.handleChange
        }, /*#__PURE__*/React.createElement(DSAccordionItem, {
          iconClosed: ChevronRight,
          iconOpened: ChevronDown,
          title: show ? hideLabel : showLabel,
          value: true
        }, /*#__PURE__*/React.createElement("div", null, display))));
      });
    }
  }]);

  return DisplayOutput;
}(Component);

export default DisplayOutput;
//# sourceMappingURL=DisplayOutput.js.map
